// Input gesture configuration
// All thresholds scaled by screen width where noted

export interface InputConfig {
  // Screen dimensions (set at runtime)
  screenWidth: number;
  screenHeight: number;

  // GatherDetector: horizontal swipe
  gatherMinStrokePx: number; // scales with screenWidth
  gatherMaxRate: number; // max strokes per second

  // RollDetector: circular motion
  rollMinRadiusPx: number; // absolute
  rollMaxRadiusPct: number; // percent of screen width
  rollMaxRate: number; // max laps per second

  // ThrowDetector: upward swipe
  throwMinDyPx: number; // minimum vertical distance
  throwMaxDurationMs: number; // maximum gesture duration
  throwMaxRate: number; // max throws per second
  throwCenterAngleDeg: number; // angle threshold for center lane

  // ButtonInput: on-screen hit rectangles
  dodgeButton: ButtonRect;
  blockButton: ButtonRect;
}

export interface ButtonRect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export function createDefaultConfig(
  screenWidth: number,
  screenHeight: number,
): InputConfig {
  return {
    screenWidth,
    screenHeight,
    // Gather: min stroke scales with width
    gatherMinStrokePx: 40 * (screenWidth / 360),
    gatherMaxRate: 12,

    // Roll: radius limits
    rollMinRadiusPx: 15,
    rollMaxRadiusPct: 0.35,
    rollMaxRate: 4,

    // Throw: vertical swipe
    throwMinDyPx: 60,
    throwMaxDurationMs: 400,
    throwMaxRate: 5,
    throwCenterAngleDeg: 20,

    // Buttons: will be set by UI layer
    dodgeButton: { x: 0, y: 0, width: 0, height: 0 },
    blockButton: { x: 0, y: 0, width: 0, height: 0 },
  };
}
